<script setup lang="ts">
import { computed, ref, watch, onMounted  } from 'vue'
import translaters from '../../tradutors/assine';
import { localeStore } from '../../stores/locale'
import { assineChoiceStore } from '../../stores/assineChoice';
import { planCreditStore } from '../../stores/planscredits'
import { planStore } from '../../stores/plans'
import { userStore } from "../../stores/user";

const storeLocale = localeStore()
const storeAssineChoice = assineChoiceStore()
const storePlan = planStore()
const storePlanCredits = planCreditStore()
const storeUser = userStore()
const creditos = ref({'12': 40, '3': 8, '1': 2})
const isActiveUser = computed(() => storeUser.isActiveUser)
const reactiveVoucher = computed(() => storePlan.voucher)
const reactiveCoupon = computed(() => storePlan.coupon)

const choice = ref({
    choiceTitle: '',
    choiceSubtitle: '',
    choiceValue: 0
})

const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref
const reactivePlans = computed(() => storePlan.plans) // Certifique-se de que locale é uma ref
const reactivePlansCredits = computed(() => storePlanCredits.plansCredits) // Certifique-se de que locale é uma ref

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

watch(reactiveLocale, () => {
    getAssineChoice()
})

onMounted(() => {
    getAssineChoice()
})

function getAssineChoice() {
    choice.value.choiceTitle = reactiveLocale.value == "pt-br" ? "Indefinido" : "Undefined"
    choice.value.choiceSubtitle = reactiveLocale.value == "pt-br" ? "Indefinido" : "Undefined"
    choice.value.choiceValue = 0
    if (storeAssineChoice.choiceId) {
        if (storeAssineChoice.choiceType == 'credits') {
            reactivePlansCredits.value.forEach(element => {
                if (element.id == storeAssineChoice.choiceId) {
                    choice.value.choiceTitle = (isActiveUser.value ? element.creditLivesAssinantes : element.creditLivesNaoAssinantes) + (reactiveLocale.value == "pt-br" ? " Créditos para Downloads" : " Downloads Credits")
                    choice.value.choiceSubtitle = isActiveUser.value ? (reactiveLocale.value == "pt-br" ? "Assinante" : "Subscriber") : reactiveLocale.value == "pt-br" ? "Não Assinante" : "Non-Subscriber"
                    choice.value.choiceValue = Number(element.discount) > 0 && element.discount_value ? +element.discount_value : +element.value
                }
            });
        } else {
            let arr = Object.values(reactivePlans.value)
            arr.forEach( element => {
                if (element.id == storeAssineChoice.choiceId) {
                    choice.value.choiceTitle = (reactiveLocale.value == "pt-br" ? "Plano " : "Plan ") + element.period
                    choice.value.choiceSubtitle = !reactiveVoucher.value && !element.discount_value ? '+' + (creditos.value[element.months] ?? 0) + (reactiveLocale.value == "pt-br" ? " Créditos para Downloads" : " Downloads Credits") : ''
                    choice.value.choiceValue = +element.discount > 0 && element.discount_value ? +element.discount_value : +element.value
                }
            });
        }
    }
}

</script>

<template>
    <div class="col-12">
        <div class="resume-title">{{ translate.resumeTitle }}</div>
        <div class="resume-line"></div>
        <div class="resume-plan1">
            {{ choice.choiceTitle }}
        </div>
        <div class="resume-plan2">
            {{ choice.choiceSubtitle }}
        </div>
        <div class="resume-line"></div>
        <div class="d-flex">
            <div class="col-6 resume-title">TOTAL:</div>
            <div class="col-6 resume-title d-flex justify-content-end">
                {{ reactiveLocale != 'pt-br' ? '$' : '' }}
                <span>&nbsp;{{ choice.choiceValue.toFixed(2).toString().split('.')[0] }},</span>
                <span class="resume-title-cents">
                    {{ choice.choiceValue.toFixed(2).toString().split('.')[1] }}
                </span>
            </div>
        </div>                        
    </div>
</template>

<style scoped lang="css">

.resume-title {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #4B4B4B;
}

.resume-title-cents {
    font-family: 'Exo-2';
    font-weight: 600;
    line-height: 32px;
    color: #4B4B4B;
    font-size: 13px;
}

.resume-line {
    border: 1px solid #DEDEDE;
}

.resume-plan1 {
    padding-top: 20px;
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #4B4B4B;
}

.resume-plan2 {
    padding-bottom: 20px;
    font-family: 'Exo-2';
    font-weight: 300;
    font-size: 14px;
    line-height: 28px;
    color: #4B4B4B;
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {

}

</style>